/* eslint-disable operator-linebreak */
import React from 'react';
import ArrowBack from '../../assets/img/back.png';

export default function NewUserBackButton({ text, onClick }) {
  const goBack = onClick || (() => window.history.back());

  return (
    <div className="k-new-user-back-wrapper">
      <button className="k-new-user-back-btn" type="button" onClick={goBack}>
        <span className="k-new-user-back-btn-text">
          <img src={ArrowBack} className="k-new-user-back-btn-arrow" alt="Back Arrow Button" />
        </span>
        {text || 'Back'}
      </button>
    </div>
  );
}
